import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  { q: "Who is HeirWise for?", a: "Families with teens ages 13+. Teens practice economic, money, and business decisions; parents get progress insight without needing to watch every step." },
  { q: "How much does HeirWise cost?", a: "Individual is $24.99/month or $249/year for one teen. Family is $39.99/month or $399/year for up to four teens. There is no free trial." },
  { q: "What will my teen experience?", a: "Teens learn through clear explanations, realistic decision practice, adaptive assessments, feedback, and simulations designed to build practical judgment." },
  { q: "What do parents see?", a: "A private insight view: lessons practiced, confidence growth, watch areas, and 2-minute conversation prompts — no need to look over their shoulder." },
  { q: "Does HeirWise provide financial advice?", a: "No. HeirWise is educational software, not a bank, lender, broker, investment adviser, or financial-services provider. Its lessons, rewards, balances, and simulations are educational." },
];

const FAQSection = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="relative py-14 sm:py-16">
      <div className="container mx-auto px-6 max-w-3xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-white/55 mb-3">
            <span className="h-1.5 w-1.5 rounded-full bg-white/50" />
            Common questions
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl text-white">Frequently asked</h2>
        </div>

        <div className="space-y-2">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="rounded-2xl border border-white/10 bg-[#11102a]/60 backdrop-blur-xl overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-white font-medium text-sm sm:text-base">{f.q}</span>
                  <ChevronDown className={`h-4 w-4 text-white/60 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm text-white/70 leading-relaxed border-t border-white/5 pt-4">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;